module.exports = __webpack_public_path__ + "static/dashboard_compressors-a00be62a7e7ba68efbc50c805afa890c.png";